import PaginacaoListagem from '@/core/store/default/paginacaoListagem'

export default {
	paginacao: PaginacaoListagem(['classificacao'], 5, 'ASC'),
	justificativa: '',
	datasource: [],
	totalElements: 0,
	totalPages: 0,

	faixaMinClassificacao: null,
	faixaMaxClassificacao: null,

	alterarClassificacao: {
		idItemAta: null,
		justificativa: '',
		alteracoes: [],
	},
}
